<template>
  <div class="panel-content" v-if="currItem.answers">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="example" v-if="!isSPC">
      {{ currItem.is_example ? $t("hsk_example") : currItem.index }}
    </div>
    <!-- 填空选项 -->
    <div class="panel-content-input">
      <div
        v-for="(item, index) in inputAnswers"
        :key="index"
        :class="[
          'input-item',
          {
            success: (!isExamMode && item.correct) || (!isExamMode && currItem.is_example),
          },
          {
            error: !isExamMode && !item.correct && !currItem.is_example,
          },
        ]"
        @click="removeInput(index, item.answerIndex, item)"
      >
        {{ item.text }}
      </div>
    </div>
    <!-- 答案选项 -->
    <div class="panel-content-answer">
      <ul class="answer-list" ref="answers">
        <li
          v-for="(item, index) in currItem.answers"
          class="answer-item"
          :key="`${currItem.index}_${index}`"
          :ref="`refAnswer${item.index}`"
          @click="checkHandler($event, item)"
        >
          <div class="item-key">
            {{ String.fromCharCode(64 + parseInt(item.index)) }}
          </div>
          <p>{{ item.content }}</p>
        </li>
      </ul>
    </div>
    <!-- 结果提示 -->
    <div class="panel-content-result result-correct" v-if="!isExamMode && isCorrect && !currItem.is_example">
      <p class="correct-tips">
        {{ $t("textbook_chioce_word_text_correct_tip") }}
      </p>
      <div class="correct-box" v-show="analysisText">
        <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
        <p class="correct-box-answer">
          {{ analysisText }}
        </p>
      </div>
    </div>

    <div class="panel-content-result result-error" v-if="!isExamMode && !isCorrect && !currItem.is_example">
      <p class="error-tips">
        {{ $t("textbook_chioce_word_text_error_tip") }}
      </p>
      <div class="result-show">
        <div class="your-answer">
          {{ $t("hsk_your_answer") }}
          <span>{{ myAnswerText }}</span>
        </div>
        <p class="correct-answer">
          {{ $t("hsk_correct_answer") }}
          <span>{{ correctAnswerText.join(",") }}</span>
        </p>
      </div>
      <div class="correct-box" v-show="analysisText">
        <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
        <p class="correct-box-answer">
          {{ analysisText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionDescription from "@/components/hsk/questionDescription";
export default {
  components: { QuestionDescription },
  data() {
    return {
      // 试题数组
      items: [],
      // 当前小题Index
      currIndex: 0,
      // 当前小题填空项
      inputAnswers: [],
      // 是否已经提交
      isSubmit: false,
      // 禁止点击
      isDisabled: false,
      // 当前小题是否作答成功
      isCorrect: null,
      changeBtn: false,
      correctAnswerText: [],
      correctAnswerArray: [],
    };
  },
  computed: {
    language() {
      let local = localStorage.getItem("language");
      if (local == "zh") {
        return "cn";
      } else {
        return local;
      }
    },
    analysisText() {
      return this.currItem.analysis[this.language]
        ? this.currItem.analysis[this.language]
        : this.currItem.analysis["cn"];
    },
    // 填空项显示的状态
    blankType() {
      if (!this.isExamMode) {
        if (this.isCorrect) {
          return "success";
        } else {
          return "error";
        }
      }
      return "";
    },
    myAnswerText() {
      let array = this.inputAnswers.map((item) => {
        return item.text ? item.text : "";
      });
      let arrayNoAnswer = array.filter((item) => item);
      return arrayNoAnswer.length > 0 ? array.join(",") : "";
    },
  },
  watch: {
    currItem: {
      handler(val) {
        console.log("val===", val);
        if (val && val.answers) {
          this.setInputAnswers();
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    // 设置填空选项
    setInputAnswers() {
      this.correctAnswerArray = [];
      this.correctAnswerText = this.currItem.correct_answer[0].answer.split(",");
      this.correctAnswerArray = this.currItem.correct_answer.map((item) => {
        return Object.assign({}, item, { answer: this.searchFlag(item.answer) });
      });
      console.log(this.correctAnswerArray);
      if (this.currItem.answer) {
        this.currItem.answer = this.searchFlag(this.currItem.answer);
        let myAnswerArray = this.currItem.answer.split(",");
        let answerSetArray = myAnswerArray.map((item) => {
          return item ? parseInt(item) : 0;
        });
        this.inputAnswers = myAnswerArray.map((item, index) => {
          return {
            text: item ? String.fromCharCode(64 + parseInt(item)) : "",
            answerIndex: item,
            correct: String.fromCharCode(64 + parseInt(item)) == this.correctAnswerText[index],
          };
        });

        this.$nextTick(() => {
          myAnswerArray.map((item) => {
            if (item) {
              this.$refs[`refAnswer${item}`][0].classList.add("active");
            }
          });
        });
        //查看结果情况下判断是否回答正确
        if (!this.isExamMode) {
          let correctAnswers = this.correctAnswerArray.map((item) => {
            return item.answer.split(",").join("");
          });
          this.isCorrect = correctAnswers.includes(answerSetArray.join(""));
          console.log(answerSetArray, this.isCorrect);
        }
      } else {
        this.isCorrect = false;
        if (this.currItem.is_example) {
          this.inputAnswers = this.correctAnswerArray[0].answer.split(",").map((item) => {
            return {
              text: item ? String.fromCharCode(64 + parseInt(item)) : "",
              answerIndex: item,
            };
          });
        } else {
          this.inputAnswers = this.currItem.answers.map((item, index) => {
            return {
              text: "",
              answerIndex: "",
            };
          });
        }
      }
    },
    // 点击答题
    checkHandler(event, option) {
      if (!this.isExamMode || this.currItem.is_example) {
        return;
      }
      const target = event.currentTarget;
      if (target.classList.contains("active")) {
        // 已选择则取消
        target.classList.remove("active");

        this.inputAnswers = this.inputAnswers.map((item) => {
          if (item.answerIndex == option.index) {
            return {
              ...item,
              text: "",
            };
          } else {
            return {
              ...item,
            };
          }
        });
      } else {
        // 未选择
        const emptyInputIndex = this.inputAnswers.findIndex((item) => item.text === "");
        if (emptyInputIndex == -1) return;
        target.classList.add("active");
        this.inputAnswers.splice(emptyInputIndex, 1, {
          answerIndex: option.index,
          text: String.fromCharCode(64 + parseInt(option.index)),
        });
      }
      this.handleSubmit();
    },
    // 点击填空，取消答案
    removeInput(inputIndex, answerIndex, item) {
      if (!this.isExamMode || this.currItem.is_example) {
        return;
      }
      if (!item.text) {
        return;
      }
      console.log(this.$refs[`refAnswer${answerIndex}`][0], answerIndex);
      this.$refs[`refAnswer${answerIndex}`][0].classList.remove("active");
      this.inputAnswers.splice(inputIndex, 1, {
        ...this.inputAnswers[inputIndex],
        text: "",
      });
      this.handleSubmit();
    },

    // 提交
    handleSubmit() {
      console.log(this.inputAnswers);
      // // 判断答案是否正确
      let correctAnswers = this.correctAnswerArray.map((item) => {
        return item.answer.split(",").join("");
      });
      console.log(this.correctAnswerArray);
      let anserArrayTextArray = this.inputAnswers.map((item) => {
        return item.text ? item.text : "";
      });
      let anserArray = this.inputAnswers.map((item) => {
        return this.searchIndex(item.text);
      });
      //选项为空的位置用0代替，方便对比连接处对错
      let answerSetArray = anserArray.map((item) => {
        return item ? item : 0;
      });
      let userAnswerStr = answerSetArray.join("");
      let userAnswer = anserArrayTextArray.join(",");
      console.log("userAnswer===", userAnswer);
      this.isCorrect = correctAnswers.includes(userAnswerStr);

      let myScore = this.isCorrect ? this.currItem.score : 0;
      //作答的对象
      let ansObj = {
        questionId: this.currItem.index,
        answer: userAnswer,
        judge: this.isCorrect ? 1 : 0,
        scores: myScore,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      };
      //选中后延时1s再提交
      setTimeout(() => {
        this.$emit("saveRes", ansObj);
      });
    },
    //根据某个text判断下标，提交答案时使用
    searchIndex(text) {
      if (!text) {
        return "";
      }
      let indexObj = this.currItem.answers.find((item) => String.fromCharCode(64 + parseInt(item.index)) === text);
      return indexObj.index;
    },

    //将正确答案拆分两两分组
    splitCorrectAnswers(array) {
      array = array.split(",");
      let length = this.currItem.answers.length;
      let answerArray = [];
      this.currItem.answers.map((item, index) => {
        if (index < length - 1) {
          answerArray.push("");
        }
      });
      answerArray = answerArray.map((element, index) => {
        return array[index] + "" + array[index + 1];
      });
      return answerArray;
    },
    //查看最终答案包含几个答案分组节点
    checkNodeNum(nodeArray, answerStr) {
      let num = 0;
      nodeArray.forEach((item) => {
        if (answerStr.indexOf(item) > -1) {
          num++;
        }
      });
      return num;
    },
    //将对应ABCD转换为1234
    searchFlag(answer) {
      let array = answer.split(",");
      array = array.map((item) => {
        item = item ? item.charCodeAt() - 64 : "";
        return item;
      });
      return array.join(",");
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 40px 29px 0px 29px;
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  &-answer {
    margin: 20px 0 40px 0;

    .answer-list {
      width: 662px;
      border-radius: 4px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .answer-item {
        cursor: pointer;
        position: relative;

        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 316px;
        min-height: 39px;
        padding: 10px 0px 10px 40px;
        font-size: 15px;
        margin-top: 10px;
        color: #3f4651;
        background: rgba(242, 243, 247, 1);
        border-radius: 5px;
        box-sizing: border-box;
        .item-key {
          position: absolute;
          font-size: 15px;
          font-weight: 600;
          color: rgba(174, 186, 198, 1);
          top: 9px;
          left: 16px;
        }
        &.active {
          color: #aebac6;
        }
        // &:hover {
        //   background: #d9dee6;
        //   color: #aebac6;
        // }
      }
    }
  }
  &-result {
    padding: 40px 30px 20px 0;
    border-top: 1px dashed #e6eaef;
    width: 100%;
    &.result-error,
    &.result-correct {
      p.error-tips {
        font-size: 14px;
        color: #fc5a5a;
        margin-bottom: 20px;
      }
      p.correct-tips {
        font-size: 14px;
        color: rgba(9, 203, 160, 1);
        margin-bottom: 20px;
      }
      .result-show {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }

      .your-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
        margin-right: 20px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 20px;
        }
      }
      p.correct-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
      }
      .correct-box {
        background: rgba(251, 252, 255, 1);
        border: 1px solid rgba(242, 243, 247, 1);
        border-radius: 10px;
        padding: 20px;

        &-title {
          font-size: 14px;
          font-weight: bold;
          color: rgba(63, 70, 81, 1);
          margin-bottom: 10px;
        }
        &-answer {
          font-size: 14px;
          font-weight: 400;
          color: rgba(84, 89, 97, 1);
          line-height: 21px;
          white-space: pre-line;
        }
      }
    }
  }
  &-input {
    width: 626px;
    min-height: 50px;
    display: flex;
    justify-content: center;
    margin: 20px auto;
    position: relative;
    .input-item {
      cursor: pointer;
      height: 48px;
      margin: 0px 29px 20px 0px;
      width: 80px;
      text-align: center;
      border-radius: 3px;
      background: #f2f3f7;
      color: #393d46;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &.success {
        background-color: rgba(230, 249, 245, 1);
        border: 1px solid rgba(9, 203, 160, 1);
        color: #09cba0;
      }
      &.error {
        background-color: rgba(254, 244, 235, 1);
        border: 1px solid #fc5a5a;
        color: #fc5a5a;
      }
    }
    .input-line {
      width: 626px;
      height: 1px;
      background-color: #fafafb;
      margin: 0 auto;
      position: absolute;
      bottom: 0px;
      left: 0px;
    }
  }
}
</style>
